import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#32DB7D",
      d: "M10.212 15.032a1.73 1.73 0 0 0-1.245-1.245l-5.314-1.37a.434.434 0 0 1 0-.834l5.314-1.37a1.73 1.73 0 0 0 1.245-1.245l1.37-5.314a.433.433 0 0 1 .834 0l1.37 5.314a1.73 1.73 0 0 0 1.245 1.245l5.314 1.37a.433.433 0 0 1 0 .835l-5.314 1.369a1.73 1.73 0 0 0-1.245 1.245l-1.37 5.314a.433.433 0 0 1-.835 0l-1.37-5.314Zm8.716-10.828V7.67zm1.732 1.733h-3.464 3.465ZM5.069 16.331v1.733zm.866.866H4.203z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#17191C",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M18.928 4.204V7.67m1.733-1.732h-3.465M5.069 16.33v1.733m.866-.867H4.203m6.009-2.165a1.73 1.73 0 0 0-1.245-1.245l-5.314-1.37a.434.434 0 0 1 0-.834l5.314-1.37a1.73 1.73 0 0 0 1.245-1.245l1.37-5.314a.433.433 0 0 1 .834 0l1.37 5.314a1.73 1.73 0 0 0 1.245 1.245l5.314 1.37a.433.433 0 0 1 0 .835l-5.314 1.369a1.73 1.73 0 0 0-1.245 1.245l-1.37 5.314a.433.433 0 0 1-.835 0l-1.37-5.314Z"
    }, null, -1)
  ])))
}
export default { render: render }